import React, { useEffect, useState } from "react";
import { ModalPadrao, LabelPadrao, InputPadrao, LoadingContainerPadrao } from "../../components/Base";
import { Input, Radio } from "antd";
import { InputNumero } from "../../components/InputNumero";
import { useFetch, useSave } from "../../components/Hooks/Conexao";
import Mensagens from "../../components/Mensagens";
import { connect } from "react-redux";
import { fetch, fetchLocalAgent } from "../../actions";
import { BtnGravar, BtnSair } from "../../components/Buttons";
import SelectFiltros from "../../components/Selects/SelectFiltros";
import { imprimirRetorno } from "../../Utils/impressaoUtils";

const INITIAL_STATE = { usuario: null, numero: null, valor: 0, historico: null };

function Lancamento({ id, onOk, onCancel, ...props }) {
  const [lancamento, listar, listando, setLancamento] = useFetch(() => props.fetch().post(`/caixa/get/mov/${id}`), INITIAL_STATE);
  const [isEntrada, setIsEntrada] = useState(true);
  const [save, saving] = useSave(() => props.fetch().post("/caixa/save/mov", { ...lancamento, isEntrada }), v => { onOk(); Mensagens.showSucesso("Lançamento gravado com sucesso!"); imprimirRetorno(props.fetchLocalAgent, v); });

  useEffect(() => { if (!!id) listar(); }, [id]);

  return <ModalPadrao
    visible={!!id}
    onCancel={onCancel}
    title="Lançamento"
    footer={<>
      {!lancamento?.caixaFechado && <BtnGravar onClick={save} disabled={!lancamento.valor} loading={saving} />}
      <BtnSair onClick={onCancel} />
    </>}>
    <LoadingContainerPadrao loading={saving || listando}>
      <div style={{ display: "flex" }}>
        <div style={{ marginRight: 10, width: "50%" }}>
          <LabelPadrao noMargin>Lançamento</LabelPadrao>
          <Radio.Group value={isEntrada} style={{ display: "flex", marginTop: 10 }} onChange={() => setIsEntrada(!isEntrada)} disabled={id > 0} >
            <Radio value={true} style={{ color: "#4791db" }}>Entrada</Radio>
            <Radio value={false} style={{ color: "#d62400" }}>Saída</Radio>
          </Radio.Group>
        </div>
        <div style={{ width: "50%" }}>
          <LabelPadrao noMargin>Operador</LabelPadrao>
          <InputPadrao value={lancamento.usuario} disabled />
        </div>
      </div>
      <div>
        <LabelPadrao>Valor</LabelPadrao>
        <InputNumero style={{ width: "100%" }} value={lancamento.valor} onChange={v => setLancamento({ ...lancamento, valor: v })} min={0} disabled={id > 0} />
      </div>
      <SelectFiltros title="Plano de contas" modelo="grupoconta" placeholder="Selecione plano de contas" value={lancamento.idPlanoConta} onChange={v => setLancamento({ ...lancamento, idPlanoConta: v })} allowClear disabled={lancamento?.caixaFechado} />
      <div>
        <LabelPadrao>Histórico</LabelPadrao>
        <Input.TextArea placeholder="Insira o histórico" value={lancamento.historico} onChange={v => setLancamento({ ...lancamento, historico: v.target.value })} disabled={id > 0} />
      </div>
    </LoadingContainerPadrao>
  </ModalPadrao>;
}

export default connect(null, { fetch, fetchLocalAgent })(Lancamento);